import './polyfills/array-find';
import './polyfills/starts-with';
import 'core-js/modules/es6.weak-map';
import 'core-js/fn/array/filter';

import React from 'react';
import ReactDOM from 'react-dom';
import Root from './root';
import './bootstrap.min.css';
import './index.css';

ReactDOM.render(
  <Root />,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js